import type { App } from 'vue';
import { registerWebSocket } from '@/plugins/websocket';
import router from '../router';
import i18n from './i18n';
import pinia from './pinia';
import vuetify from './vuetify';

export function registerPlugins(app: App) {
    app.use(i18n).use(vuetify).use(router).use(pinia);

    registerWebSocket();
}
